import { catchError, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { PaymentModeDataService } from '../services/payment-mode-data.service';

@Component({
  selector: 'kt-payment-mode-position-edit',
  templateUrl: './payment-mode-position-edit.component.html',
  styleUrls: ['./payment-mode-position-edit.component.scss']
})
export class PaymentModePositionEditDialogComponent implements OnInit, OnDestroy {

  form: FormGroup;
  messages$ = this.paymentModeDataService.messages$;
  refreshStatus: boolean;
  buttonLoading = false;

  private subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { paymentMode: any },
    public dialogRef: MatDialogRef<PaymentModePositionEditDialogComponent>,
    private paymentModeDataService: PaymentModeDataService,
  ) { }

  ngOnInit() {
    this.formInit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.onRefresh();
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }

  onSave() {
    this.buttonLoading = true;
    // Disable save button while request is in progress.
    this.form.setErrors({ invalid: true });

    const paymentOptions = Object.values(this.form.value.payment_options || {});
    const payload = {
      payment_options: paymentOptions,
    };

    this.paymentModeDataService.updatePaymentModePosition(this.data.paymentMode.id, payload).pipe(
      tap(() => {
        this.buttonLoading = false;
        this.form.setErrors(null);
      }),
      catchError((error) => {
        this.buttonLoading = false;
        this.form.setErrors(null);
        throw error;
      })
    ).subscribe();

    this.refreshStatus = true;
  }

  onRefresh() {
    if (this.refreshStatus === true) {
      this.dialogRef.close(true);
    }
  }

  private formInit() {
    this.form = new FormGroup({
      payment_mode_name: new FormControl({ value: this.data.paymentMode.name, disabled: true }),
      payment_options: new FormGroup(this.buildPaymentOptions()),
    });
    this.form.markAllAsTouched();
    this.form.markAsDirty();
  }

  private buildPaymentOptions = () => {
    let paymentOptions = {};

    this.data.paymentMode.payment_options.forEach((item, index) => {
      const paymentOptionGroup = new FormGroup({
        payment_mode_payment_option_id: new FormControl(item.payment_mode_payment_option_id),
        position: new FormControl(item.position, [Validators.required, Validators.min(1), Validators.max(99)]),
      });

      paymentOptions = { ...paymentOptions, [index]: paymentOptionGroup };
    });

    return paymentOptions;
  };
}
